import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// ACCOUNTS DASHBOARD WIDGETS
// RoleId/UserId drive backend CC-scoping: for roles with ApplicableForCC='Yes',
// results are restricted to the cost centers assigned to this user in UserCostCenters.
// ==============================================

export const getCCCashBalanceSummary = async ({ roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetCCCashBalanceSummary`,
            { params: { RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ CC Cash Balance Summary API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// Tile counts: pending bank transactions / vendor invoices (all workflow levels), FDs nearing their
// end date and LCs nearing their validity date (next 30 days).
export const getAccountsDashboardSummary = async ({ roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetAccountsDashboardSummary`,
            { params: { RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Accounts Dashboard Summary API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// Drill-down behind a tile (type = 'Bank' | 'VendorInvoice' | 'FDEnd' | 'LCDue'). The workflow types
// carry the level they are pending at (PendingLevel) and the role(s) at that level (PendingWithRole).
export const getAccountsPendingDetails = async ({ type, roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetAccountsPendingDetails`,
            { params: { Type: type, RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Accounts Pending Details API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
